/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './leaveConvo.defs.js'
export * as $defs from './leaveConvo.defs.js'
